import { useState } from "react";
import { applyTextScale, getTextScale, TEXT_LEVELS, TEXT_LABELS } from "@/lib/textScale";
import { IconTextSize } from "@/components/icons/revqIcons";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

const STEP_BTN = "w-[28px] h-[26px] flex items-center justify-center font-semibold leading-none hover:bg-[#F4F4F9] disabled:hover:bg-transparent disabled:cursor-default";

// Footer "Text size" row — stepper over the shared text-size setting.
// Collapsed: a 40×34 icon button that opens the same row + stepper in a menu to the right.
export function TextSizeControl({ collapsed }) {
  const [scale, setScale] = useState(getTextScale());
  const i = TEXT_LEVELS.indexOf(scale);
  const step = (d) => setScale(applyTextScale(TEXT_LEVELS[Math.min(TEXT_LEVELS.length - 1, Math.max(0, i + d))]));
  const atMin = i <= 0, atMax = i >= TEXT_LEVELS.length - 1;

  const row = (
    <div className="flex items-center h-[34px] gap-[10px] pl-[10px] pr-[4px]" data-testid="text-size-control">
      <span className="flex-none text-[#6C6C69]"><IconTextSize size={18} stroke={1.75} /></span>
      <span className="flex-1 min-w-0 text-[13.5px] text-[#141412] truncate">Text size</span>
      <div className="flex-none flex items-center h-[28px] rounded-[8px] bg-white overflow-hidden" style={{ border: "1px solid #E9E9EC" }} data-testid="text-size-stepper">
        <button type="button" aria-label="Smaller text" disabled={atMin} onClick={() => step(-1)} className={`${STEP_BTN} text-[11px]`} style={{ color: atMin ? "#C9C9CE" : "#141412" }} data-testid="text-size-smaller">A</button>
        <span aria-live="polite" title={TEXT_LABELS[scale]} className="min-w-[44px] h-[26px] flex items-center justify-center text-[11.5px] text-[#6E6E6B] tabular-nums" style={{ borderLeft: "1px solid #E9E9EC", borderRight: "1px solid #E9E9EC" }} data-testid="text-size-value">{scale}%</span>
        <button type="button" aria-label="Larger text" disabled={atMax} onClick={() => step(1)} className={`${STEP_BTN} text-[15px]`} style={{ color: atMax ? "#C9C9CE" : "#141412" }} data-testid="text-size-larger">A</button>
      </div>
    </div>
  );

  if (collapsed) {
    return (
      <Popover>
        <PopoverTrigger asChild>
          <button data-testid="text-size-toggle" title={`Text size · ${scale}%`} aria-label={`Text size ${scale}%`}
            className="flex-none mx-auto w-[40px] h-[34px] grid place-items-center rounded-[8px] text-[#6C6C69] hover:bg-[#F4F4F9] data-[state=open]:bg-[#F4F4F9] data-[state=open]:text-[#141412]">
            <IconTextSize size={18} stroke={1.75} />
          </button>
        </PopoverTrigger>
        <PopoverContent side="right" align="end" sideOffset={10} className="w-[232px] p-[4px] rounded-[10px]"
          style={{ border: "1px solid #E9E9EC", boxShadow: "0 10px 28px rgba(20,20,18,.14)" }} data-testid="text-size-menu">
          {row}
        </PopoverContent>
      </Popover>
    );
  }
  return <div className="flex-none">{row}</div>;
}
